import { createContext, ReactNode, useCallback } from 'react';
import { Message } from 'types/Message';
import { emptyFunction } from 'utils/functions';
import { StateSetter } from 'types/utils/React';

export type UpdateSelectedMessagesType = (
  message: Message,
  isAdd: boolean,
) => void;

export type AdminMessagesContextProps = {
  selectedMessages: Message[];
  resetSelectedMessages: () => void;
  setSelectedMessages: StateSetter<Message[]>;
  updateSelectedMessages: UpdateSelectedMessagesType;
};

const initialState = {
  selectedMessages: [],
  resetSelectedMessages: emptyFunction,
  setSelectedMessages: emptyFunction,
  updateSelectedMessages: emptyFunction,
};

const adminMessagesContext =
    createContext<AdminMessagesContextProps>(initialState),
  { Provider } = adminMessagesContext;

type AdminMessagesContextProviderProps = {
  children: ReactNode;
  selectedMessages: Message[];
  setSelectedMessages: StateSetter<Message[]>;
};

const AdminMessagesContextProvider = ({
  children,
  selectedMessages,
  setSelectedMessages,
}: AdminMessagesContextProviderProps): JSX.Element => {
  const updateSelectedMessages = useCallback(
    (message: Message, isAdd: boolean) => {
      if (isAdd) {
        setSelectedMessages([...selectedMessages, message]);
      } else {
        const updatedSelectedMessages = selectedMessages.filter(
          (_) => _.id !== message.id,
        );
        setSelectedMessages(updatedSelectedMessages);
      }
    },
    [selectedMessages, setSelectedMessages],
  );

  const resetSelectedMessages = useCallback(
    () => setSelectedMessages([]),
    [setSelectedMessages],
  );

  return (
    <Provider
      value={{
        selectedMessages,
        resetSelectedMessages,
        setSelectedMessages,
        updateSelectedMessages,
      }}
    >
      {children}
    </Provider>
  );
};

export { adminMessagesContext, AdminMessagesContextProvider };
